import { render } from "./Table4.vue?vue&type=template&id=4665aa9f"
import script from "./Table4.vue?vue&type=script&lang=js"
export * from "./Table4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__